import { range } from "lodash-es";
import client from "./client";
import { LocalCacheKey } from "constants/cacheKeys";
import { BaseResponse } from "./common";

const customIntervals = new Map();
export const customSetInterval = (callback, interval) => {
  const id = Symbol(); // 创建一个唯一标识符

  function recursiveTimeout() {
    if (!customIntervals.has(id)) return; // 如果定时器已被清除，则不再执行
    callback();
    customIntervals.set(id, setTimeout(recursiveTimeout, interval));
  }
  customIntervals.set(id, setTimeout(recursiveTimeout, interval));
  return id; // 返回这个唯一标识符
};

export const customClearInterval = (id) => {
  clearTimeout(customIntervals.get(id));
  customIntervals.delete(id);
};

export default client;

/**
 * 清空全部 api 缓存
 */
export function cleanLocalStorageCache() {
  range(localStorage.length)
    .map((i) => localStorage.key(i))
    .filter((k) => {
      return (
        k.startsWith(LocalCacheKey.CONTRACT_GRADIENT_MD5_KEY) ||
        k.startsWith(LocalCacheKey.CONTRACT_GRADIENT_DATA) ||
        k.startsWith(LocalCacheKey.CONTRACT_LIST_MD5_KEY) ||
        k.startsWith(LocalCacheKey.CONTRACT_LIST_DATA) ||
        k.startsWith(LocalCacheKey.spot_isolated_config_md5) ||
        k.startsWith(LocalCacheKey.spot_isolated_config_Md5_data) ||
        k.startsWith(LocalCacheKey.spot_cross_config_md5) ||
        k.startsWith(LocalCacheKey.spot_cross_config_md5_data) ||
        // TODO: 清理旧版本 key， 上线运行一段时间后可移除此逻辑
        k.startsWith("ct-list-md5-key") ||
        k.startsWith("ct-list-data")
      );
    })
    .forEach((k) => localStorage.removeItem(k));
}

export const createCachedAsyncFunction = (
  asyncFunction: (arg: any) => Promise<BaseResponse<any>>
) => {
  const cache = {};
  return async function (arg: any = {}) {
    const key = JSON.stringify(arg);
    if (cache[key]) {
      return cache[key];
    } else {
      const res = await asyncFunction(arg);

      if (res && ["200", "00000"].includes(res?.code)) {
        cache[key] = res;
        // 设置一个定时器，在3秒后清除缓存
        setTimeout(() => {
          delete cache[key];
        }, 3000);
      }
      return res;
    }
  };
};
